// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		//is explorer
		function msieversion() {

			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}

			return false;
		}

		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		var scrollParallax = []
		var scrolled = 0

		// screen height
		var v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") // get it from html
			//get distance in positive value
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				//get distance in negative value (to do the scroll inverse)
				distance = distance * -1
			}
			//Equivalent distance using screen height + element height
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				//Obtain the distance between top screen and document top 0
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				//Distance of bottom page to top of the element
				let relative_distance = scrolled + v_height - topElement
				//transpoling data to move the parallax element relative to the scroll of all the screen
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, // relative to document viewport
				rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				threshold: 0 // visible amount of item shown in relation to root
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	//scroll down js-scrolldown animateTo(target)
	if(document.getElementsByClassName('js-scrolldown').length > 0){
		document.getElementsByClassName('js-scrolldown')[0].addEventListener('click', function(){
			animateTo('intro');
		});
	}

	if(document.getElementsByClassName('btn-open-table-home').length > 0){
		document.getElementsByClassName('btn-open-table-home')[0].addEventListener('click', function(){
			animateTo('open_table');
		});
	}



	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		});
		
		//Event click menus
		$('li.menu-item-tab').on('click',function(){
			location.hash=$(this).data('menuname').toLowerCase().replace(" ",'_');
		});

		if(location.pathname.indexOf('/menus')>-1 && location.hash.length>0){
			let hashTittle = titleCase(location.hash.replace('_','').replace('#','')).replace(' ','').replace("'",'').replace("&39;",'').replace("%20",'');
			animateTo('menus');
			$('li.menu-item-tab.js-menu-tab.'+hashTittle.toLowerCase()).trigger('click')
		}
	};



}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 10){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
//vanilla js scroll animation

function animateTo(target){
	var gotoTarget = offset(document.getElementById(target)).top - 20;
	var from     = window.pageYOffset;
	var to       = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start;

		if(from <= to ){
			var y = easeInOutQuart(time, from, to - from, duration)
		} else {

			var y = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, y)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function titleCase(str) {
	var splitStr = str.toLowerCase().split(' ');
	for (var i = 0; i < splitStr.length; i++) {
		// You do not need to check if i is larger than splitStr length, as your for does that for you
		// Assign it back to the array
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
	}
	// Directly return the joined string
	return splitStr.join(' '); 
 }
